/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

/** "Liberar o plano completo" (RN-10): when the plan renews once the trial ends today. */

/**
 * The day the next charge falls on once the trial ends today.
 *
 * Monthly renews on the same day next month (clamped to a short month);
 * yearly is the backend's +365 days.
 *
 * @param from - Today.
 * @param frequency - The billing cycle.
 * @returns The date of the next charge.
 */
export function nextChargeAfter(from: Date, frequency: 'monthly' | 'yearly'): Date {
  if (frequency === 'yearly') {
    return new Date(from.getFullYear(), from.getMonth(), from.getDate() + 365);
  }
  const lastDay = new Date(from.getFullYear(), from.getMonth() + 2, 0).getDate();
  return new Date(from.getFullYear(), from.getMonth() + 1, Math.min(from.getDate(), lastDay));
}
